import { Tax } from './Tax';

export class Amount {
  base: number;
  price: number;
  taxes: Tax[];

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/Amount.ts